import { useMutation, useQueryClient } from '@tanstack/react-query';

interface BulkSuggestSharedJobPostCandidatesParams {
  sharedJobPostIds: number[];
  candidateProfileIds: number[];
}

export default function useBulkSuggestSharedJobPostCandidates() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      sharedJobPostIds,
      candidateProfileIds,
    }: BulkSuggestSharedJobPostCandidatesParams) => {
      const response = await fetch(`/agent/api/shared_job_posts/suggest.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          shared_job_post_ids: sharedJobPostIds,
          candidate_profile_ids: candidateProfileIds,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'シェア求人の提案に失敗しました');
      }

      return response.json();
    },
    onSuccess: () => {
      // シェア求人一覧を再取得
      queryClient.invalidateQueries({ queryKey: ['sharedJobPosts'] });
    },
  });
}
